import WalletPanel from "./WalletPanel";

export default function TopBanner() {
    return (
        <div style={{marginTop: '10px', marginBottom: '10px', height: '40px', width: '100%', backgroundColor: '#333333', borderRadius: '10px'
        }}>
            <div className='flexRow' style={{float: 'left', fontSize: '25px'}}>
                <div style={{width: '1px'}}> </div>
                <div><img alt='' src='/assemblyline-icon-32.png' style={{marginTop: '5px', width: '35px'}}/></div>
                <div style={{fontFamily: 'FastHand'}}>Assembly Line</div>
            </div>
            <div className='flexRow' style={{float: 'right', marginTop: '5px'}}>
                <WalletPanel />
                <div style={{width: '1px'}}> </div>
            </div>
        </div>
    )
}